export default {
      id: "footer-usage",
      viewBox: "0 0 2100 75",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#footer-usage",
      toString: function () {
        return this.url;
      }
    }